export enum AssociationStatus {
    Pending = 'pending',
    Editing = 'editing',
    ApprovalPending = 'approval-pending',
    Approved = 'approved',
};